module.exports = __webpack_public_path__ + "img/car4.225e783d.jpg";